import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  destinationType: "None",
  destinationScreen: "",
  externalLink: "",
  displayText: "",
  notificationTypeSettings: "General", // new field
};

const notificationDestinationSlice = createSlice({
  name: "notificationDestination",
  initialState,
  reducers: {
    setDestinationType(state, action) {
      state.destinationType = action.payload;
    },
    setDestinationScreen(state, action) {
      state.destinationScreen = action.payload;
    },
    setExternalLink(state, action) {
      state.externalLink = action.payload;
    },
    setDisplayText(state, action) {
      state.displayText = action.payload;
    },
    setNotificationSettings(state, action) {
      state.notificationTypeSettings = action.payload;
    },
    clearDestination(state) {
      return initialState;
    },
  },
});

export const {
  setDestinationType,
  setDestinationScreen,
  setExternalLink,
  setDisplayText,
  setNotificationSettings, // export new action
  clearDestination,
} = notificationDestinationSlice.actions;

export default notificationDestinationSlice.reducer;
